import router from '../router'

export default {
  state: {
    user: {},
    token: null,
    status: false,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setToken(state, token) {
      state.token = token
      axios.defaults.headers.common = {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    },
    setStatus(state, payload) {
      state.status = payload
    },
    logout(state) {
      state.user = {}
      state.token = null
      state.status = false
    },
  },
  actions: {
    queryAuth({dispatch, commit}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'account')
        .then(res => {
          dispatch('setPreloader', false)
          commit('setUser', res.data.user)
        })
    },
    registration({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'registration', payload)
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 201) {
            dispatch('setToast', [res.data.message, 'success'])
          } else {
            dispatch('setToast', ['Registration failed', 'warning'])
          }
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response)
        })
    },
    login({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'auth', payload)
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 203) {
            dispatch('setToast', [res.data.message, 'warning'])
            window.location = res.data.link
          } else {
            commit('setUser', res.data.user)
            commit('setToken', res.data.token)
            commit('setStatus', true)
            dispatch('setToast', ['Authentication success', 'success'])
            router.push('/dashboard')
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            dispatch('setToast', ['Email or password is not correct', 'warning'])
          } else if (error.response.status === 423) {
            dispatch('setToast', ['Account not activated', 'warning'])
          } else {
            dispatch('setToastHttpError', error.response)
          }
          dispatch('setPreloader', false)
        })
    },
    logout({commit, dispatch}) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'logout')
        .then(res => {
          commit('logout')
          dispatch('setToast', [res.data.message, 'success'])
          dispatch('setPreloader', false)
          router.push('/login')
        })
    },
    restorePassword({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'restore-password', payload)
        .then(res => {
          dispatch('setPreloader', false)
          dispatch('setToast', [res.data.message, 'success'])
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response)
        })
    },
    restoreConfirm({commit, dispatch}, payload) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'restore-confirm', payload)
        .then(res => {
          dispatch('setPreloader', false)
          dispatch('setToast', [res.data.message, 'success'])
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response)
        })
    }
  },
  getters: {
    getAuthUser: state => {
      return state.user
    },
    getAuthStatus: state => {
      return state.status
    },
  }
}